import { useQuery } from "@tanstack/react-query";
import { OrganizationEloSettingsDto } from "../../../models/organization/dto/organization.dto";
import { useApiClient } from "../../../apiClient";

export const GET_ELO_SETTINGS_QUERY_KEY = (organizationId: string) => ['organization', organizationId, 'eloSettings'];

export const useGetEloSettings = (organizationId: string) => {
    const apiClient = useApiClient();

    return useQuery<OrganizationEloSettingsDto>({
        queryKey: GET_ELO_SETTINGS_QUERY_KEY(organizationId),
        queryFn: () =>
            apiClient.fetchApi<OrganizationEloSettingsDto, {}>({
                method: 'GET',
                endpoint: `organizations/${organizationId}/elo-settings`,
            }),
        enabled: !!organizationId,
        staleTime: 5 * 60 * 1000,
    });
};
